<template>
  <nav v-if="!route.meta.hideChrome" class="bottom-nav safe-bottom" aria-label="Primary">
    <div class="bottom-nav-inner">
      <RouterLink
        v-for="item in navItems"
        :key="item.to"
        :to="item.to"
        class="bottom-link"
        :class="{ 'bottom-link-active': isActive(item.to) }"
      >
        <Icon :icon="item.icon" class="bottom-link-icon" width="22" height="22" />
        <span class="bottom-link-label">{{ item.label }}</span>
      </RouterLink>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { RouterLink, useRoute } from "vue-router";
import Icon from "./Icon.vue";

const route = useRoute();

type NavItem = {
  to: string;
  label: string;
  icon: string;
};

const navItems: NavItem[] = [
  { to: "/", label: "Search", icon: "lucide:search" },
  { to: "/saved", label: "Saved", icon: "lucide:bookmark" },
  { to: "/favorites", label: "Favorites", icon: "lucide:heart" },
  { to: "/account", label: "Account", icon: "lucide:user-round" }
];

function isActive(path: string) {
  return route.path === path;
}
</script>
